import gql from 'graphql-tag';

const getActiveOrder = gql`
  query getActiveOrder {
    activeOrder {
      id
      Account {
        AcctName
        AcctNo
        Address
        AddressOptions {
          Addr {
            text
            value
            id
          }
          Def
        }
        Days
        Level
        Coop
      }
      ShipTo
      OrderType
      OrderTypes {
        text
        value
      }
      OrderTypeValue
      OrderDate
      OrderNo
      Note
      Coop
      Po
      Det {
        Mobo
        Code
        Qty
        MoboQty {
          OrderNo
          OrderNoMobo
          Qty
        }
        Description
      }
      FlatDet: Det(flatten: true) {
        Code
        Cases
        Bottles
        Description
      }
    }
  }
`;

export default getActiveOrder;
